import Spinner from 'react-bootstrap/Spinner';

export default function LoadingModal () {
    return(
         <div
            style={{
              height: "100vh",
              width: "100vw",
              position: "fixed",
              top: 0,
              left: 0,
              background: "rgba(255,255,255,0.35)",
              backdropFilter: "blur(6px)",
              WebkitBackdropFilter: "blur(6px)",
              zIndex: 9999,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                background: "rgba(255,255,255,0.85)",
                padding: "35px 45px",
                borderRadius: 24,
                boxShadow: "0 10px 40px rgba(0,0,0,0.12)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 20,
              }}
            >
              <Spinner
                animation="border"
                role="status"
                style={{
                  width: 70,
                  height: 70,
                  color: "#482979",
                  borderWidth: 6,
                }}
              />

              <div
                style={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: "#482979",
                  letterSpacing: 0.5,
                }}
              >
                Loading...
              </div>
            </div>
          </div>
    )
}